<template>
    <div class="board-container" @click="getMouseXY($event)">
        <VueDragResize class="board-msg" :isActive="false" v-for="item in formAllData" :key="item.id"
                       :isDraggable="this.$store.state.core.currentUser?.id == item.create_user_id || this.$store.state.core.currentUser?.id =='U0001' "
                       :isResizable="false" :parentLimitation = "true"  :x="item.mouse_x" :y="item.mouse_y"
                       :w="200"  :h="150" :parentW="1900" :parentH="900" v-on:dragging="changePosition">
            <div class="my-container" @click="updateCoordinate($event,item.id,item.create_user_id)">
                <div :style="{color:item.color,fontSize:item.font_size,fontFamily:item.font_family}">{{item.content}}</div>
                <el-image v-if="item.url" :src="item.url" :preview-src-list="[item.url]"
                          :style="{width:item.image_width,height:item.image_height}"
                          :initial-index="0" fit="cover" preview-teleported="true" />
                <div style="font-size: 10px;color:#999999; margin-top: -8px;margin-left: 5px">{{item.create_user_name}} {{item.create_time}}
                    <el-button  @click="selectPublicBoard($event,item.id)" type="success" link>详情</el-button>
                </div>
            </div>
        </VueDragResize>
    </div>

    <el-dialog title="发布公告" v-model="dialogFormVisible" width="30%">
        <el-tabs v-model="activeName" class="demo-tabs">
            <el-tab-pane label="文字" name="first">
                <el-form :model="formData" :rules="rules" label-width="100px">
                    <el-form-item  label="内容：" prop="star" >
                        <el-input type="textarea"  style="width: 250px"
                          v-model="formData.content" placeholder="请输入内容"/>
                    </el-form-item>
                    <el-form-item label="字体大小：" prop="star" >
                        <el-select v-model="formData.font_size" style="width: 250px" clearable>
                            <el-option  v-for="dict in fontSize" :key="dict.value" :label="dict.name" :value="dict.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="字体颜色：" prop="star" >
                        <el-select v-model="formData.color" style="width: 250px" clearable>
                            <el-option  v-for="dict in fontColor" :key="dict.value" :label="dict.name" :value="dict.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="字体：" prop="star" >
                        <el-select v-model="formData.font_family" style="width: 250px" clearable>
                            <el-option  v-for="dict in fontFamily" :key="dict.value" :label="dict.name" :value="dict.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button @click="submit" :loading="loading">发布</el-button>
                    </el-form-item>
                </el-form>
            </el-tab-pane>
            <el-tab-pane label="图片" name="second">
<!--                <FrameForm componentParam="oa_public_board_image_add" :init-data="formData"/>-->
              <el-form :model="formData" :rules="rules" label-width="100px">
                <el-form-item label="图片：" prop="star">
                    <FrameItem v-model="formData.image_id" :item="photo"></FrameItem>
                </el-form-item>
                <el-form-item label="图片宽度：" prop="star" >
                  <el-input v-model="formData.image_width" placeholder="请输入图片宽度" style="width: 250px" clearable>
                  </el-input>
                </el-form-item>
                <el-form-item label="图片高度：" prop="star" >
                  <el-input v-model="formData.image_height" placeholder="图片高度" style="width: 250px" clearable>
                  </el-input>
                </el-form-item>
                <el-form-item>
                  <el-button @click="submit" :loading="loading">发布</el-button>
                </el-form-item>
              </el-form>
            </el-tab-pane>
        </el-tabs>
    </el-dialog>


    <el-dialog title="发布详情" v-model="dialogVisible" width="30%">
                <el-form :model="publicBoard" label-width="100px">
                    <el-row>
                        <el-col :span="6" class="item-text">发布时间：</el-col>
                        <el-col :span="18" class="item-value">{{publicBoard.create_time}}</el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="6" class="item-text">发布人：</el-col>
                        <el-col :span="18" class="item-value"> {{publicBoard.create_user_name}}</el-col>
                    </el-row>
                    <el-row v-if="publicBoard.content">
                        <el-col :span="6" class="item-text">发布内容：</el-col>
                        <el-col :span="18" class="item-value"> {{publicBoard.content}}</el-col>
                    </el-row>
                    <el-row v-if="publicBoard.url">
                        <el-col :span="6" class="item-text">图片：</el-col>
                        <el-col :span="18" class="item-value">
                            <el-image :src="publicBoard.url" :preview-src-list="[publicBoard.url]"
                                      style="width: 350px ;height: 250px;margin-top: 30px"
                                      :initial-index="0" fit="cover" preview-teleported="true" />
                        </el-col>
                    </el-row>
                    <el-row v-if="this.$store.state.core.currentUser?.id == publicBoard.create_user_id || this.$store.state.core.currentUser?.id =='U0001'">
                        <el-col :span="6" class="item-text"></el-col>
                        <el-col :span="18" class="item-value">
                            <el-button  @click="deletePublicBoard" type="danger" :loading="loading">删除</el-button>
                        </el-col>
                    </el-row>
                </el-form>
    </el-dialog>

</template>

<script>
    import VueDragResize from "vue-drag-resize/src";
    import moment from 'moment/moment'
    moment.locale('zh-cn')

    export default {
        name: "PublicBoard",
        components: { VueDragResize },
        data() {
            return {
              dialogVisible:false,
              loading: false,
              dialogFormVisible: false,
              activeName:'first',
              formAllData:[],
              publicBoard:[],
              formData: {
                mouse_x: '',
                mouse_y: '',
                content:'',
                color: '',
                font_size: '',
                font_family:'',
                image_id:'',
                image_width:'',
                image_height:''
              },
              coordinateData:{
                top:'',
                left:'',
              },
              photo: {
                component: 'image_upload',
                limit: 1,
              },
              rules: {
                  star: [{required: true, message: '', trigger: 'blur'}],
                },
            }
        },
        computed: {
            fontSize() {
              return this.$store.getters['core/getDictList']('font_size');
            },
            fontColor() {
              return this.$store.getters['core/getDictList']('font_color');
            },
            fontFamily() {
              return this.$store.getters['core/getDictList']('font_family');
            }
        },
        mounted(){},

        methods: {
          //获取移动坐标
            changePosition(newRect) {
              this.coordinateData.top = newRect.top
              this.coordinateData.left = newRect.left
            },
            //修改移动后的坐标
            updateCoordinate(e,id,create_user_id){
              e.stopPropagation()
              if (this.$store.state.core.currentUser?.id == create_user_id || this.$store.state.core.currentUser?.id =='U0001'){
                this.coordinateData.id = id
                this.$axios.post('publicBoard/updateCoordinate',this.coordinateData)
              }
            },
            //查询详情
            selectPublicBoard(e,id) {
              e.stopPropagation() //阻止事件冒泡
              this.dialogVisible = true
              console.log(id)
              this.$axios.post('publicBoard/getPublicBoard',id).then(response => {
                let res = response.data
                console.log(res)
                this.publicBoard = res
              })
            },
            getMouseXY(e) {
              this.dialogFormVisible = true
              this.formData.mouse_x = e.pageX - 5
              this.formData.mouse_y = e.pageY - 80
              // console.log( this.formData.mouse_x);
              // console.log(this.formData.mouse_y);
            },
            //查询所以信息
            async selectAllPublicBoard() {
              this.formAllData = await this.$http('oaPublicBoardService.getAll')
            },
            deletePublicBoard(){
              this.dialogVisible = false
              this.$confirm('你确定要删除，这个公告吗？','提示' , {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                   type: 'warning'
              }).then(() => {
                this.$axios.post('publicBoard/deletePublicBoard', this.publicBoard.id).then(response => {
                  let res = response.data
                  if (res.code != 0) {
                    return this.$message({
                      type: 'error',
                      message: '删除失败!'
                    });
                  }
                  this.selectAllPublicBoard();
                  return this.$message({
                    type: 'success',
                    message: '删除成功!'
                  });
                })
              }).catch(() => {
                this.$message({
                  type: 'info',
                  message: '已取消删除'
                });
              });
            },
            async submit() {
              if(this.activeName == 'first'){
                if (!this.formData.content) {
                  return  this.$message({
                    type: 'error',
                    message: '内容不能为空!'
                  })
                }
                if (!this.formData.font_size) {
                  return  this.$message({
                    type: 'error',
                    message: '字体大小不能为空!'
                  })
                }
                if (!this.formData.color) {
                  return  this.$message({
                    type: 'error',
                    message: '字体颜色不能为空!'
                  })
                }
                if (!this.formData.font_family) {
                  return  this.$message({
                    type: 'error',
                    message: '字体不能为空!'
                  })
                }
                this.formData.image_id = []
                this.formData.image_height = ''
                this.formData.image_width = ''
              }
              if(this.activeName == 'second'){
                if (this.formData.image_id.length === 0) {
                  return  this.$message({
                    type: 'error',
                    message: '图片不能为空!'
                  })
                }
                if (!this.formData.image_width) {
                  return  this.$message({
                    type: 'error',
                    message: '图片宽度不能为空!'
                  })
                }
                if (!this.formData.image_height) {
                  return  this.$message({
                    type: 'error',
                    message: '图片高度不能为空!'
                  })
                }
                this.formData.content = ''
                this.formData.font_size = ''
                this.formData.color = ''
                this.formData.font_family = ''
              }
              this.loading = true;
              this.formData.failure_time = moment(new Date(this.formData.failure_time)).format('yyyy-MM-DD HH:mm:ss ')
              console.log()
              await this.$http('oaPublicBoardService.add', this.formData)
              this.loading = false;
              this.formData.mouse_x = ''
              this.formData.mouse_y = ''
              this.formData.content = ''
              this.formData.font_size = ''
              this.formData.color = ''
              this.formData.font_family = ''
              this.formData.image_id = []
              this.formData.image_height = ''
              this.formData.image_width = ''
              this.dialogFormVisible = false;
              this.selectAllPublicBoard()
              return this.$message({
                type: 'success',
                message: '发布成功!'
              });
            }
        },
        created() {
          this.selectAllPublicBoard()
        }
    }
</script>

<style scoped>
.board-container{
    width:100%;
    height:100%;
    position: relative
}
.board-msg{
    position: absolute;

}
.vdr.active:before {
   display:none;
}

.my-container{
    white-space: nowrap;
}
.item-text{
    text-align: right;
    font-size: 20px;
    line-height: 40px;
}

.item-value{
    font-size: 20px;
    line-height: 40px;

}

</style>